import React, { useState } from 'react';

// 1. نستقبل lang و setLang كـ props من App.js
const Navbar = ({ lang, setLang }) => {
  
  // نلغي تعريف حالة اللغة من هنا لأننا استلمناها من الأب
  // const [lang, setLang] = useState('ar');  <-- هذا السطر تم حذفه

  // حالة قائمة الموبايل تظل هنا (لأنها خاصة بالنافبار فقط)
  const [isOpen, setIsOpen] = useState(false);

  const content = {
    ar: {
      home: "الرئيسية",
      services: "خدماتنا",
      team: "فريق العمل",
      contact: "اتصل بنا",
      cta: "حجز استشارة",
      logoSubtitle: "للمحاماة والاستشارات",
      langBtn: "English"
    },
    en: {
      home: "Home",
            services: "Services",
      team: "Our Team",
      contact: "Contact Us",
      cta: "Book Consultation",
      logoSubtitle: "Law Firm",
      langBtn: "عربي"
    }
  };

  const t = content[lang]; 

  const toggleLanguage = () => {
    // نستخدم دالة setLang القادمة من App.js
    setLang((prev) => (prev === 'ar' ? 'en' : 'ar'));
    setIsOpen(false); 
  };

  return (
    <nav className={`navbar ${lang === 'ar' ? 'rtl' : 'ltr'}`} dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      
      <div className="navbar-container">
        {/* زر الموبايل */}
        <div className="menu-toggle" onClick={() => setIsOpen(!isOpen)}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        {/* الشعار */}
        <a href="/" className="logo">
           {/* تم إضافة كلاس للصورة للتحكم في حجمها */}
           <img 
             src="https://res.cloudinary.com/defcamc5x/image/upload/v1765723761/oixtx7xrw1eourt7mkf3.png" 
             alt="El-Wakil Logo" 
             className="logo-img"
           />
        </a>

        {/* الروابط */}
        <ul className={`nav-links ${isOpen ? 'active' : ''}`}>
          <li><a href="#home" onClick={() => setIsOpen(false)}>{t.home}</a></li>
          <li><a href="#services" onClick={() => setIsOpen(false)}>{t.services}</a></li>
          <li><a href="#team" onClick={() => setIsOpen(false)}>{t.team}</a></li>
          <li><a href="#contact" onClick={() => setIsOpen(false)}>{t.contact}</a></li>
          
          <li className="mobile-only">
             <button className="lang-switch-mobile" onClick={toggleLanguage}>{t.langBtn}</button>
          </li>
        </ul>

        {/* الأزرار الجانبية */}
        <div className="nav-actions">
          <button className="lang-switch" onClick={toggleLanguage}>
            {t.langBtn}
          </button>
          <a href="#contact" className="cta-btn">{t.cta}</a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;